import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TicketsListHeader = ({
  reloadList,
  changeStatusHandler,
  openCreateTicket = () => {},
}) => {
  const { t } = useTranslation();
  const breadcrumbTxt = [{ title: "Tickets" }];
  // const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  return (
    <div className="filter-container py-3">
      <div className="row align-items-center">
        {/* ------- search section -------- */}
        <div className="col-md-5 col-lg-6 d-none d-md-block mb-3 mb-md-0">
          <BreadCrumb breadCrumbText={breadcrumbTxt} />
        </div>

        <div className="col-md-7 col-lg-6 d-flex justify-content-end gap-1 gap-sm-2">
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-gray d-flex align-items-center"
          >
            <span className="d-block material-symbols-outlined icon-md">
              refresh
            </span>
            <span className="d-block">{t("Refresh")}</span>
          </Link>

          

          {/* ------- import section ---------- */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-gray dropdown-toggle d-flex align-items-center"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="d-block material-symbols-outlined icon-md">
                upload
              </span>
              <span className="d-block">{t("Import")}</span>
            </button>

            <ul className="dropdown-menu bg-white fs-sm border-0 rounded-10 shadow-sm">
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    sync
                  </span>
                  <span className="d-block">{t("Import from OneBox")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#clorianImportModal"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    sync
                  </span>
                  <span className="d-block">{t("Import from Clorian")}</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* ------- action section ---------- */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-gray dropdown-toggle d-flex align-items-center"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="d-block">{t("Action")}</span>
            </button>

            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-10 shadow-sm">
              {/* -------- delete ----------- */}
              <li>
                <Link
                  onClick={changeStatusHandler}
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-1"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* --------- filter ---------- */}
          <Link
            to="#"
            className="btn btn-gray d-flex align-items-center gap-1"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasTicketListFilter"
            aria-controls="offcanvasTicketListFilter"
          >
            <span className="d-block material-symbols-outlined icon-md">
              tune
            </span>
            <span className="d-block">Filter</span>
          </Link>

          {/* add New --- */}
          <Link
            onClick={openCreateTicket}
            to="#"
            className="btn btn-primary d-flex align-items-center"
            data-bs-toggle="offcanvas"
            data-bs-target="#createUpdateTicketOffcanvas"
            aria-controls="createUpdateTicketOffcanvas"
          >
            <span className="d-block material-symbols-outlined icon-md">
              add
            </span>
            <span className="d-block">{t("Add Ticket")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TicketsListHeader;
